import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  private showSideKick$ = new Subject<boolean>(); 
  showSideKick: Observable<boolean> = this.showSideKick$.asObservable();
  private showSideKickValue: boolean = false;

  private showSideNav$ = new Subject<boolean>();
  showSideNav: Observable<boolean> = this.showSideNav$.asObservable();
  private showSideNavValue: boolean = false;

  constructor() { }
  
  displaySideKick(show: boolean) {
    this.showSideKickValue = show;
    this.showSideKick$.next(this.showSideKickValue);
  }

  displaySideNav(show: boolean) {
    this.showSideNavValue = show;
    this.showSideNav$.next(this.showSideNavValue);
  }
}
